import { ArticleModel, MyWrittenArticlesClient, MyGroupingOfArticlePropDTO, MoveArticlesClient, ArticleMoveDTO, ListItemDTO, PublicationModel, PublicationClient, PublicationType, ArticleModelArticleType } from "../Generated/ParticaAPI";
import { ParticaItem, ParticaSubItem } from "@/Models/ParticaItem";
import { ArticleUtils } from "./articleutils";
import { IWrittenArticle } from "@/Models/ArticleModels/article";
import { PublicationService } from "./publication";

export interface IWrittenArticleService {
	getArticlesByPublication(customerAccountId: number): Promise<ParticaItem[]>;
	getArticle(articleId: string): Promise<IWrittenArticle>;
	saveArticle(article: IWrittenArticle, publicationId: number): Promise<IWrittenArticle>;
	moveArticle(articleId: string, publicationId: number): Promise<any>;
	moveArticles(articleId: string[], publicationId: number): Promise<any>;
	getWrittenPublications(customerAccountId: number): Promise<PublicationModel[]>;
	addFolder(accountId: number, name: string): Promise<any>;
	updateFolderName(folderId: number, name: string): Promise<any>;
}

export class WrittenArticleService implements IWrittenArticleService {
	private svc: MyWrittenArticlesClient = new MyWrittenArticlesClient();
	private movesvc: MoveArticlesClient = new MoveArticlesClient();
	private articleUtils: ArticleUtils = new ArticleUtils();
	private pubsvc: PublicationClient = new PublicationClient();

	public async addFolder(accountId: number, name: string): Promise<any> {
		await this.pubsvc.addPublication(accountId, PublicationType.Written, name);
	}

	public async updateFolderName(folderId: number, name: string): Promise<any> {
		await this.pubsvc.renamePublication(folderId, name);
	}

	public async getWrittenPublications(customerAccountId: number): Promise<PublicationModel[]> {
		const pubs: PublicationModel[] = await this.svc.getWrittenArticlePublications(customerAccountId);
		return pubs;
	}

	public async saveArticle(article: IWrittenArticle, publicationId: number): Promise<IWrittenArticle> {
		let am = article.get<ArticleModel>();
		if (publicationId === 0) {
			if (am.issue === undefined) {
				throw new Error("No publicationId specified.");
			} else {
				publicationId = am.issue.publicationId as number;
			}
		}
		am.issue = undefined;
		am.articleType = ArticleModelArticleType.Written;
		am = await this.svc.saveWrittenArticle(am, publicationId);
		return this.articleUtils.convertarticle<IWrittenArticle>(am);
	}

	public async moveArticles(articleIds: string[], publicationId: number) {
		const moveDetails = new ArticleMoveDTO();
		moveDetails.articleGuids = articleIds;
		moveDetails.publicationId = publicationId;
		await this.movesvc.moveArticles(moveDetails);
	}

	public async moveArticle(articleId: string, publicationId: number) {
		const moveDetails = new ArticleMoveDTO();
		moveDetails.articleGuids = [articleId];
		moveDetails.publicationId = publicationId;
		await this.movesvc.moveArticles(moveDetails);
	}

	public async getArticle(articleId: string): Promise<IWrittenArticle> {
		const article: ArticleModel = await this.svc.getWrittenArticle(articleId);
		const written: IWrittenArticle = this.articleUtils.convertarticle<IWrittenArticle>(article);
		return written;
	}

	public async getArticlesByPublication(CustomerAccountId: number): Promise<ParticaItem[]> {
		const publications: MyGroupingOfArticlePropDTO[] = await this.svc.getWrittenArticles(CustomerAccountId);
		const result: ParticaItem[] = [];
		publications.forEach(pub => {
			const item: ParticaItem = { id: pub.id, name: pub.name, items: [], open: false, children: [] } as ParticaItem;
			if (pub.elements !== undefined) {
				pub.elements.forEach(element => {
					if (element.parentId !== undefined) {
						const sub: ParticaSubItem = {
							icon: "", id: element.articleId as string, name: element.title as string, parentid: element.parentId.toString(), optional: ""
						} as ParticaSubItem;
						if (element.syndicated === true) {
							sub.icon = "monetization_on";
						}
						if (element.streams as number > 0) {
							sub.optional = `${element.streams} stream(s)`;
						}
						item.items.push(sub);
					}
				});
			}
			result.push(item);
		});
		return result;

	}
}
